import { axios } from "@/utils/request";

//获取验证码
export function getcode(data) {
    return axios({
        url: "/common/v1/sms",
        method: "POST",
        data
    });
}

//登录
export function login(data) {
    return axios({
        url: "/merchant/v1/users/login",
        method: "POST",
        data
    });
}

//注册
export function register(data) {
    return axios({
        url: "/merchant/v1/users/register",
        method: "POST",
        data
    });
}

//忘记密码
export function repassword(data) {
    return axios({
        url: "/merchant/v1/users/forget",
        method: "POST",
        data
    });
}

//修改密码
export function changepwd(data) {
    return axios({
        url: "/merchant/v1/user/changePwd",
        method: "POST",
        data
    });
}

//获取背景图片
export function getback(data) {
    return axios({
        url: "/merchant/v1/config",
        method: "GET",
        data
    });
}

//获取站点名字
export function getConfig(data) {
    return axios({
        url: "/common/v1/config",
        method: "GET",
        data
    });
}